import { utcToZonedTime } from 'date-fns-tz';
import useTimezoneOffsetValues from 'hooks/useTimezoneOffsetValues';
import get from 'lodash/get';
import { DEFAULT_TABLE_COUNT } from 'utils/constants/social-lounge';
import useTimezoneUtils from '../../common/TimezoneSelector/useTimezoneUtils';
import { getNearestQuarter } from '../../common/utils';

export const useInitialValues = (airmeet, community) => {
    const { localTzOption } = useTimezoneUtils();
    const { timezone } = airmeet || {};
    const timeZone = useTimezoneOffsetValues({ timezone });
    const { name: org_name } = community || {};
    const initialState = {
        name: '',
        description: '',
        isPrivate: true,
        isAttendeeList: false,
        noAuth: false,
        initDate: getNearestQuarter().toDate(),
        finalDate: getNearestQuarter().add(1, 'hours').toDate(),
        timeZone: get(localTzOption, 'value', ''),
        hasVirtualTables: true,
        hasTicketing: false,
        tableCount: DEFAULT_TABLE_COUNT,
        longDesc: '',
        supportEmail: '',
        eventOrganiserName: org_name || '', // The default value of eventOrganiserName will be the community name
    };
    if (airmeet) {
        const {
            name,
            short_desc,
            is_private,
            noauth_enabled,
            attendee_list_enabled,
            start_time,
            end_time,
            timezone,
            networking_enabled,
            tableCount,
            event_type,
            long_desc,
            support_email,
            event_organiser_name,
            community_name,
        } = airmeet || {};

        return {
            ...initialState,
            name,
            description: short_desc,
            isPrivate: is_private,
            noAuth: noauth_enabled,
            isAttendeeList: attendee_list_enabled,
            initDate: utcToZonedTime(new Date(start_time), timeZone),
            finalDate: utcToZonedTime(new Date(end_time), timeZone),
            timeZone: timezone,
            hasVirtualTables: networking_enabled,
            tableCount: tableCount,
            eventType: event_type,
            longDesc: long_desc,
            supportEmail: support_email,
            eventOrganiserName:
                event_organiser_name || community_name || org_name,
        };
    }
    return initialState;
};
